import React, { Component } from 'react'
import { connect } from 'react-redux'
import { confirmationPop, setSuccessFailPop } from '../../action/viewBillAction2'
import { checkOut, guestBillDetails } from '../../../action/viewBillAction'
import { CMSPath, DEMO, ENABLE_NEW_CHECKOUT_FLOW } from '../../../config/constant'
import { logoutUserHandler } from '../../../action/homeAction'
import { validateGuestdetail } from '../../../action/action'
import { fetchSessionToken } from '../../../JS/fetchSessionToken'
import {withTranslation} from "react-i18next";
import { wipeGuestData } from '../../../JS/wipeGuestData'

class SuccessFailCheckoutPopUp extends Component {

    constructor(props){
        super(props)
        this.timeout = null
        this.timeDelay = null
        this.state = {
            roomNumber : localStorage.getItem("room"),
            timeDelay: 3,
            timerTimeout: 10000,
            checkoutSuccess: false,
            checkOutButtonClicked:false
        }
    }
    
    onContinue = () => {
        this.setState({checkOutButtonClicked: true});
        wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})


        // if(localStorage.getItem('GuestCheckedOut')){
        //     localStorage.removeItem('GuestCheckedOut')
        //     this.props.setSuccessFailPop(false, false)
        // }
        // console.log("onSuccess");

        // let encodData = fetchSessionToken();
        // this.props.validateGuestdetail(encodData, "someone", "something",(status) => {
        //     document.location.reload();
        //     // this.props.setSuccessFailPop(false, false);
        // });
    }

    onClose = () => {
        this.props.setSuccessFailPop(false, false);
    }

    tryAgain = () => {
        this.props.showLoader(true, 'Please wait checkout is in process')
        this.props.setSuccessFailPop(false, false);
        this.props.checkOut(this.props.selectedGuest, this.props.billTotal, this.onSuccess, this.onFailure);
    }

    callBillDetails = () => {
        this.props.guestBillDetails(this.props.selectedGuest, this.callbackBillDetails);
    }

    callbackBillDetails = (xcValue, status, msg) => {
        if(status){
            console.log('xcValue', xcValue)
            if(xcValue=='SUCCESS'){
                console.log('checkout success')
                clearInterval(this.interval)
                clearTimeout(this.timeout)
                this.props.showLoader(false, '')
                // this.props.checkoutSuccess(true)
                this.props.setSuccessFailPop(true, true);
            } else if(xcValue=='FAILED'){
                console.log('checkout failed status:', status)
                clearTimeout(this.timeout)
                this.billDetailsFailure(msg)
            }
        } else {
            console.log('checkout failed status:', status)
            clearTimeout(this.timeout)
            this.billDetailsFailure(msg)
        }
    }

    billDetailsFailure = (errorMsg) => {
        clearInterval(this.interval);
        this.props.showLoader(false, '');
        this.props.setSuccessFailPop(true, false, errorMsg);
    }

    onSuccess = (msg) => {
        console.log("onSuccess");
        if(DEMO || !ENABLE_NEW_CHECKOUT_FLOW){
            this.props.setLoader(false, '');
            this.props.checkoutSuccess(true);
            this.props.setSuccessFailPop(true, true);
            return;
        }
        this.interval = window.setInterval(
            () => {
                console.log('calling bull details api')
                this.props.guestBillDetails(this.props.selectedGuest, this.callbackBillDetails);
            }, this.state.timeDelay
            
        )
        this.timeout = window.setTimeout(
            () => {
                console.log('checkout failed')
                clearTimeout(this.timeout)
                this.billDetailsFailure()
            }, this.state.timerTimeout
        )
    }

    onFailure = (msg) => {
        console.log("onFailure");
        this.props.setSuccessFailPop(true, false, msg);
    }

    componentDidMount() {
        if(this.props.timeIntervalsBillDetail){
            let timeDelay= this.props.timeIntervalsBillDetail.split(',')[0] * 1000
            let timerTimeout= this.props.timeIntervalsBillDetail.split(',')[1] * 1000
            this.setState({timeDelay:timeDelay, timerTimeout:timerTimeout})
        }

    }

    render() {
        const { t } = this.props
        return (
            <section class="overlay">
                {
                    this.props.sucFailPopStatus ? 
                        <div class="overlay-window-container">
                            <div class="overlay-window no-bg success">
                                <div class="overlay-content">
                                    <div class="header">
                                        <div class="header-icon">
                                            {/* <i class="fas fa-check"></i> */}
                                            <p>{t('view_bill.checkout_success_txt')}</p>
                                        </div>
                                        <div class="header-text">
                                            <h3 style = {{height:"10rem"}}>{t('view_bill.checkout_greeting_line')}</h3>
                                        </div>
                                    </div>
                                    <div class="hotel-logo">
                                        <img src={`${CMSPath}${this.props.logo}`} style={{ fill: "#fff", maxHeight:"2rem" }} />
                                        {t('view_bill.checkout_greeting_line2')}
                                    </div>
                                </div>
                                <div class="overlay-controls">
                                    {/* <button class="button secondary btn-action align-left">Share your experience</button>
                                    <button class="button secondary btn-action align-left">Share feedback</button> */}
                                        <button onClick={this.onContinue} 
                                        style = {{
                                            backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                                            color: this.props.menuColor.assetFontSelectorColor
                                        }}
                                        class={`button ${this.state.checkOutButtonClicked ? "checkoutButtonClicked": ""}`}>{t('view_bill.continue')}</button>
                                </div>
                            </div>
                        </div>
                        :
                        <div class="overlay-window-container">
                            <div class="overlay-window no-bg error view-folio">
                                <div class="overlay-content">
                                    <div class="header">
                                        <div class="header-icon">
                                            {/* <i class="fas fa-times"></i> */}
                                            <p>{(!this.props.sucFailMessage || process.env.REACT_APP_VIEW_FOLIO_ERROR_POPUP_CUSTOM_TEXT == "true" )&& t('view_bill.checkout_fail_txt')}</p>
                                        </div>
                                        <div class="header-text">
                                            <h3 style={{fontSize: '200%'}}>{process.env.REACT_APP_VIEW_FOLIO_ERROR_POPUP_CUSTOM_TEXT == "true" ? t('view_bill.checkout_error_txt2') : this.props.sucFailMessage || t('view_bill.checkout_error_txt2')}</h3>
                                        </div>
                                        <p>{process.env.REACT_APP_VIEW_FOLIO_ERROR_POPUP_CUSTOM_TEXT == "true" ? t('view_bill.checkout_error_txt3') : null} </p>
                                    </div>
                                    <div class="hotel-logo">
                                        <img src={`${CMSPath}${this.props.logo}`} style={{ fill: "#fff" }} />
                                        {/* {t('view_bill.checkout_error_txt2')} */}
                                </div>
                                </div>
                                <div class="overlay-controls">
                                    {/* <button class="button secondary" 
                                    style = {{
                                        backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                                        color: this.props.menuColor.assetFontSelectorColor
                                    }}
                                    onClick={this.tryAgain} style = {{backgroundColor:this.props.menuColor.assetBackgroundSelectorColor, color : this.props.menuColor.assetFontSelectorColor}}>{t('view_bill.try_again')}</button> */}
                                    <button class="button" onClick={this.onClose}>Close</button>
                                </div>
                            </div>
                        </div>
                }
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        billTotal: state.store.viewBill.billTotal,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        selectedGuest: state.store2.viewBill.selectedGuest,
        showSucFailPop: state.store2.viewBill.showSucFailPop,
        sucFailPopStatus: state.store2.viewBill.sucFailPopStatus,
        sucFailMessage: state.store2.viewBill.sucFailMessage,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        timeIntervalsBillDetail: state.store.home.clientConfig.extraConfigParam 
            ? state.store.home.clientConfig.extraConfigParam.EXPRESS_CHECKOUT_TIME_INTERVALS : "",
    }
}

export default connect(
    mapStateToProps,
    {
        confirmationPop,
        checkOut,
        setSuccessFailPop,
        validateGuestdetail,
        guestBillDetails,
        logoutUserHandler
    }
)(withTranslation('translations')(SuccessFailCheckoutPopUp));